import clientConfig from '../../client-config.json'

import { CLIENT_CONFIG, CURRENT_CLIENT } from '@/constants'

export function isProfilePdfEnabled(): boolean {
  const fromTenant = (
    CURRENT_CLIENT as { features?: { profilePdf?: { enabled?: boolean } } }
  ).features?.profilePdf?.enabled
  if (fromTenant === true) return true
  const clients = clientConfig as {
    clients?: Record<string, { features?: { profilePdf?: { enabled?: boolean } } }>
  }
  return clients.clients?.[CLIENT_CONFIG]?.features?.profilePdf?.enabled === true
}
